import './loader-global.css';
import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import { parseDOMString, removeElement } from '../../_utils';
import { SafeHTML } from '../../safe-html';
import { getLoaderTemplate } from './loader-global-template';
export const LoaderGlobal = ({ children, id, className, loadingText = '', inProgressLoadingMessages = [], loadingWaitTime = 30000, hideLoader = false, isTransparentBg = false, highOpacity = false, loadingTextClassName = '', isLoaderInOverlay = false, ...restProps }) => {
    const [loadingInfoText, setLoadingInfoText] = useState(loadingText);
    useEffect(() => {
        let count = 0;
        // If loading text is '' then take the first value from inProgressLoadingMessages
        if (loadingText === '' && inProgressLoadingMessages.length > 0) {
            setLoadingInfoText(inProgressLoadingMessages[0]);
            count = 1;
        }
        else {
            setLoadingInfoText(loadingText);
        }
        const timer = setInterval(() => {
            if (count < (inProgressLoadingMessages === null || inProgressLoadingMessages === void 0 ? void 0 : inProgressLoadingMessages.length)) {
                setLoadingInfoText(inProgressLoadingMessages[count]);
                count++;
            }
            else {
                clearInterval(timer);
            }
        }, loadingWaitTime);
        return () => clearTimeout(timer);
    }, [inProgressLoadingMessages, loadingText, loadingWaitTime]);
    // Reference for the class is in loader-global.scss
    let opacityClass = highOpacity
        ? 'rdLoadingIndicatorHighOpacity'
        : 'rdLoadingIndicatorLowOpacity';
    if (isLoaderInOverlay) {
        opacityClass = 'rdLoadingIndicatorOverlay';
    }
    const loaderClassNames = cx('rdLoaderGlobalWrap', {
        rdHideLoader: hideLoader,
    }, className);
    const template = getLoaderTemplate(opacityClass, loadingTextClassName);
    const getloaderHtmlString = (text) => {
        if (text) {
            return parseDOMString(template, '#data-loading-text', text);
        }
        return removeElement(template, '#data-loading-text');
    };
    return (React.createElement("div", { id: id, className: loaderClassNames, "data-display-name": LoaderGlobal.displayName, ...restProps },
        React.createElement(SafeHTML, { html: getloaderHtmlString(loadingInfoText), className: isTransparentBg ? 'rdOverrideStyle' : '' }),
        children));
};
LoaderGlobal.displayName = 'radiant_react_loading_indicator_global';
//# sourceMappingURL=loader-global.js.map